if (typeof Zoom !== " function") {
  window.Zoom = function (wrapper, duracion, formato, data) {
    let box = new Box({
      size: { width: 1600, height: 1200 },
      padding: 20,
    });

    let projection = d3.geoMercator();
    let path = d3.geoPath();

    let svg = null;
    let gMapa = null;
    let gMunicipios = null;
    let gEstados = null;
    let gLeyenda = null;

    let svgLeyenda = null;
    let gEtiquetas = null;

    let estados = data.estados;
    let municipios = data.municipios;

    const color = d3.scaleSymlog().range(["#ffffff", "#ff0000"]);
    const colorMunicipios = d3.scaleSymlog().range(["#ffffff", "#ff0000"]);
    const arregloEstados = [];
    let flagZoom = "estados";

    let maxZoom = 20;
    const zoom = d3
      .zoom()
      .scaleExtent([1, maxZoom])
      .on("start", handleStart)
      .on("zoom", handleZoom)
      .on("end", handleEnd);
    let k = 1;

    function setup() {
      crearSVG(wrapper);
      procesarDatos();
      procesarDatosMunicipios();
      crearMapa();
      crearLeyenda();
    }

    function crearSVG(wrapper) {
      svg = wrapper
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", `0 0 ${box.width} ${box.height}`);

      svg = svg.append("g");

      svg = svg
        .append("g")
        .attr(
          "transform",
          `translate(${box.padding.left}, ${box.padding.top})`,
        );

      gMapa = svg
        .append("g")
        .attr("data-g", "gMapa")
        .attr("class", "zoomeable");

      gMunicipios = gMapa
        .append("g")
        .attr("stroke", "#b8b8b8ff")
        .attr("stroke-width", 0.5)
        .attr("fill", "transparent")
        .attr("data-g", "gMunicipios");

      gEstados = gMapa
        .append("g")
        .attr("stroke", "#b8b8b8ff")
        .attr("stroke-width", 2)
        .attr("fill", "transparent")
        .attr("data-g", "gEstados");

      gLeyenda = svg.append("g").attr("data-g", "gLeyenda");
    }

    function procesarDatos() {
      let arreglo = _.map(
        estados.objects.estados.geometries,
        (d) => d.properties.tasa_contagios,
      );
      arreglo = _.filter(arreglo, (d) => d != null);
      color.domain([0, d3.max(arreglo)]);

      _.each(estados.objects.estados.geometries, function (d) {
        arregloEstados.push({
          CVE_ENT: d.properties.CVE_ENT,
          NOM_ENT:
            d.properties.NOM_ENT == "México"
              ? "Estado de México"
              : d.properties.NOM_ENT,
        });
      });

      arregloEstados.sort((a, b) => a.NOM_ENT.localeCompare(b.NOM_ENT));

      const selectEstado = d3.select("#estado");
      const grupo = selectEstado.select("optgroup:nth-child(2)").node();

      _.each(arregloEstados, function (d) {
        const newOption = new Option(d.NOM_ENT, d.CVE_ENT);
        grupo.appendChild(newOption);
      });
      selectEstado.on("change", (e) => {
        e.preventDefault();
        let valor = selectEstado.property("value");
        if (valor == "pais") {
          zoomPais();
        } else {
          zoomEstado(valor);
        }
      });
    }

    function procesarDatosMunicipios() {
      _.each(municipios.objects.municipios.geometries, function (d) {
        d.properties.tasa_contagios =
          d.properties.contagios == null
            ? 0
            : (d.properties.contagios * 100000) / d.properties.poblacion;
      });

      let arreglo = _.map(
        municipios.objects.municipios.geometries,
        (d) => d.properties.tasa_contagios,
      );
      arreglo = _.filter(arreglo, (d) => d != null);
      colorMunicipios.domain([0, d3.max(arreglo)]);
    }

    function crearMapa() {
      estados = topojson.feature(estados, estados.objects.estados);
      estados = estados.features;

      municipios = topojson.feature(municipios, municipios.objects.municipios);
      municipios = municipios.features;

      let obj = {
        type: "FeatureCollection",
        features: estados,
      };

      projection.fitSize([box.content.width, box.content.height], obj);
      path.projection(projection);

      gMunicipios
        .selectAll("path")
        .data(municipios)
        .enter()
        .append("path")
        .attr("d", path)
        .attr("fill", function (d) {
          let c = null;
          if (d.properties.tasa_contagios != null) {
            c = colorMunicipios(d.properties.tasa_contagios);
          }
          return c;
        })
        .on("mouseover", crearTooltipMunicipio)
        .on("mouseout", deshacerTooltipMunicipio);

      gEstados
        .selectAll("path")
        .data(estados)
        .enter()
        .append("path")
        .attr("d", path)
        .attr("fill", function (d) {
          let c = null;
          if (d.properties.tasa_contagios != null) {
            c = color(Math.ceil(d.properties.tasa_contagios));
          }
          return c;
        })
        .on("mouseover", crearTooltip)
        .on("mouseout", deshacerTooltip);
    }

    function crearLeyenda() {
      gLeyenda
        .attr("transform", "translate(196,1120)")
        .style("stroke-width", "2px");

      let rect = gLeyenda.append("rect").style("fill", "#ffffff");

      let arreglo = [0, 1, 5, 10, 50, 100];
      let l = 50;
      let x = 0;

      gLeyenda
        .append("text")
        .text("Tasa por cada cien mil habitantes")
        .attr("x", (arreglo.length * l) / 2)
        .attr("y", -50)
        .style("font-size", "32px")
        .attr("text-anchor", "middle");

      _.each(arreglo, function (d) {
        gLeyenda
          .append("rect")
          .attr("data-tipo", "leyenda")
          .attr("width", l)
          .attr("height", l)
          .attr("x", x)
          .attr("y", 0)
          .style("fill", color(d))
          .style("stroke", "#b8b8b8");

        gLeyenda
          .append("text")
          .attr("data-tipo", "leyenda")
          .text(d)
          .attr("x", x + l / 2)
          .attr("y", -6)
          .style("font-size", "24px")
          .attr("text-anchor", "middle");

        x += l;
      });

      let caja = gLeyenda.node().getBBox();
      rect
        .attr("x", caja.x - 10)
        .attr("y", caja.y - 10)
        .attr("width", caja.width + 20)
        .attr("height", caja.height + 20);
    }

    function crearTooltip(e, d) {
      if (d.properties.contagios != null) {
        let entidad =
          d.properties.NOM_ENT == "México"
            ? "Estado de México"
            : d.properties.NOM_ENT;
        let [x, y] = d3.pointer(e, this);
        let el = d3.select(this);
        let cajaPath = el.node().getBBox();
        y = cajaPath.y;

        el.raise().style("stroke-width", "4px").style("stroke", "#000000");

        let gTooltip = svg.append("g").attr("class", "tooltip ignore");

        let rect = gTooltip
          .append("rect")
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", 0)
          .attr("height", 0)
          .style("fill", "#ffffff")
          .style("stroke", "gray")
          .style("stroke-width", "2px");

        let text = gTooltip
          .append("text")
          .attr("x", 0)
          .attr("y", 0)
          .attr("dy", 0)
          .attr("text-anchor", "middle");

        text.append("tspan").style("font-weight", 700).text(`${entidad}`);

        text
          .append("tspan")
          .attr("x", 0)
          .attr("y", formato == "horizontal" ? 34 : 44)
          .style("font-weight", 700)
          .text(`${d.properties.tasa_contagios.toFixed(2)}`);
        text.append("tspan").text(` contagios por cada 100,000 habitantes`);

        let caja = text.node().getBBox();

        y -= caja.height - 10;
        y = y <= 0 ? 20 : y;

        rect
          .attr("x", caja.x - 10)
          .attr("y", caja.y - 10)
          .attr("width", caja.width + 20)
          .attr("height", caja.height + 20);

        let overflow = x + (caja.x - 10) + (caja.width + 20);
        let underflow = x - (caja.x - 10 + (caja.width + 20));
        let width = caja.width + 20;

        if (overflow > box.content.width) {
          gTooltip.attr(
            "transform",
            `translate(${box.content.width - width / 2}, ${y})`,
          );
        } else if (underflow < 0) {
          gTooltip.attr("transform", `translate(${0 + width / 2}, ${y})`);
        } else {
          gTooltip.attr("transform", `translate(${x}, ${y})`);
        }
      }
    }

    function deshacerTooltip(e, d) {
      let el = d3.select(this);
      el.style("stroke-width", null).style("stroke", null);
      svg.selectAll("g.tooltip").remove();
    }

    function zoomEstado(valor) {
      svg.selectAll("g.tooltip").remove();

      let obj = _.find(estados, function (d) {
        return d.properties.CVE_ENT == valor;
      });
      const [[x0, y0], [x1, y1]] = path.bounds(obj);

      let pathEstados = gEstados.selectAll("path");
      let pathEstado = pathEstados.filter(function (d) {
        return d.properties.CVE_ENT == valor;
      });
      let pathMunicipios = gMunicipios.selectAll("path");
      let pathMunicipiosEstado = pathMunicipios.filter(function (d) {
        return d.properties.CVE_ENT == valor;
      });

      pathEstados
        .style("fill", "transparent")
        .style("stroke", null)
        .style("pointer-events", "none");
      pathEstado
        .raise()
        .transition()
        .style("fill", "transparent")
        .style("stroke", "#000000");

      pathMunicipios
        .style("fill", "transparent")
        .style("stroke", "transparent")
        .style("pointer-events", "none");
      pathMunicipiosEstado
        .raise()
        .transition()
        .style("fill", null)
        .style("stroke", null)
        .style("pointer-events", null);

      flagZoom = "municipios";

      gMapa.transition().call(
        zoom.transform,
        d3.zoomIdentity
          .translate(box.content.width / 2, box.content.height / 2)
          .scale(
            Math.min(
              maxZoom,
              0.9 /
                Math.max(
                  (x1 - x0) / box.content.width,
                  (y1 - y0) / box.content.height,
                ),
            ),
          )
          .translate(-(x0 + x1) / 2, -(y0 + y1) / 2),
      );

      actualizarLeyenda("municipios");
    }

    function handleStart(event) {
      gMapa.style("pointer-events", "none");
    }

    function handleEnd(event) {
      gMapa.style("pointer-events", null);
    }

    function handleZoom(event) {
      const { transform } = event;
      gMapa.attr("transform", transform);
      gMapa.attr("stroke-width", 1 / transform.k);
      gEstados.style("stroke-width", 2 / transform.k);
      gMunicipios.style("stroke-width", 0.5 / transform.k);
      k = transform.k;
    }

    function crearTooltipMunicipio(e, d) {
      if (d.properties.contagios != null) {
        let entidad =
          d.properties.NOM_ENT == "México"
            ? "Estado de México"
            : d.properties.NOM_ENT;
        let [x, y] = d3.pointer(e);

        let el = d3.select(this);
        let cajaPath = el.node().getBBox();
        y = cajaPath.y;

        let coords = getSvgCoordinates(e, gMapa.node());

        el.raise()
          .style("stroke-width", `${2 / k}px`)
          .style("stroke", "#000000");

        let gTooltip = svg.append("g").attr("class", "tooltip ignore");

        let rect = gTooltip
          .append("rect")
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", 0)
          .attr("height", 0)
          .style("fill", "#ffffff")
          .style("stroke", "gray")
          .style("stroke-width", `${2 / k}px`);

        let text = gTooltip
          .append("text")
          .attr("x", 0)
          .attr("y", 0)
          .attr("dy", 0)
          .attr("text-anchor", "middle")
          .style("font-size", `${(formato == "horizontal" ? 24 : 44) / k}px`)
          .style("fill", "#000000");

        text
          .append("tspan")
          .style("font-weight", 700)
          .text(`${d.properties.NOM_MUN}, ${entidad}`);

        text
          .append("tspan")
          .attr("x", 0)
          .attr("y", (formato == "horizontal" ? 34 : 54) / k)
          .style("font-weight", 700)
          .text(`${d.properties.tasa_contagios.toFixed(2)}`);
        text.append("tspan").text(` contagios por cada 100,000 habitantes`);

        let caja = text.node().getBBox();

        y -= caja.height - 10 / k;
        y = y <= 0 ? 20 : y;

        rect
          .attr("x", caja.x - 10 / k)
          .attr("y", caja.y - 10 / k)
          .attr("width", caja.width + 20 / k)
          .attr("height", caja.height + 20 / k);

        let overflow = x + (caja.x - 10 / k) + (caja.width + 20 / k);
        let underflow = x - (caja.x - 10 / k + (caja.width + 20 / k));
        let width = caja.width + 20 / k;

        if (overflow > box.content.width) {
          gTooltip.attr(
            "transform",
            `translate(${box.content.width - width / 2}, ${y})`,
          );
        } else if (underflow < 0) {
          gTooltip.attr("transform", `translate(${0 + width / 2}, ${y})`);
        } else {
          gTooltip.attr("transform", `translate(${x}, ${y})`);
        }

        let gMapaTooltip = gMapa.attr("transform");
        let transformTooltip = gTooltip.attr("transform");
        gTooltip.attr("transform", `${gMapaTooltip}${transformTooltip}`);
      }
    }

    function deshacerTooltipMunicipio(e, d) {
      let el = d3.select(this);
      el.style("stroke-width", null).style("stroke", null);
      svg.selectAll("g.tooltip").remove();
    }

    function getSvgCoordinates(event, svgElement) {
      const ctm = svgElement.getScreenCTM();
      if (ctm) {
        const inverseCTM = ctm.inverse();
        const svgPoint = new DOMPoint(event.clientX, event.clientY);
        const transformedPoint = svgPoint.matrixTransform(inverseCTM);
        return {
          x: transformedPoint.x,
          y: transformedPoint.y,
        };
      }
      return null;
    }

    function zoomPais() {
      let pathEstados = gEstados.selectAll("path");
      pathEstados
        .style("fill", null)
        .style("stroke", null)
        .style("pointer-events", null);

      gMapa.transition().call(zoom.transform, d3.zoomIdentity);

      actualizarLeyenda("pais");
    }

    function actualizarLeyenda(tipo) {
      let l = 50;
      let x = 0;

      let arreglo =
        tipo == "pais" ? [0, 1, 5, 10, 50, 100] : [0, 10, 50, 100, 500, 1000];
      let getColor = tipo == "pais" ? color : colorMunicipios;

      gLeyenda.selectAll("text[data-tipo='leyenda']").remove();
      gLeyenda.selectAll("rect[data-tipo='leyenda']").remove();

      _.each(arreglo, function (d) {
        gLeyenda
          .append("rect")
          .attr("data-tipo", "leyenda")
          .attr("width", l)
          .attr("height", l)
          .attr("x", x)
          .attr("y", 0)
          .style("fill", getColor(d))
          .style("stroke", "#b8b8b8");

        gLeyenda
          .append("text")
          .attr("data-tipo", "leyenda")
          .text(d)
          .attr("x", x + l / 2)
          .attr("y", -6)
          .style("font-size", "24px")
          .attr("text-anchor", "middle");

        x += l;
      });
    }

    setup();
  };
}
